export class FacebookModule {
  public static trackEvent(event: string, params?: unknown) {
    if (!FB_PIXEL_LIST || !window.fbq) {
      console.error('Facebook pixel is not initialized', FB_PIXEL_LIST);
      return;
    }

    console.log('Facebook log event: ', event, params);
    window.fbq('track', event, params);
  }

  public static trackCustomEvent(event: string, params?: unknown) {
    if (!FB_PIXEL_LIST || !window.fbq) {
      console.error('Facebook pixel is not initialized', FB_PIXEL_LIST);
      return;
    }

    console.log('Facebook log custom event: ', event, params);
    window.fbq('trackCustom', event, params);
  }
}
